import { createSlice } from "@reduxjs/toolkit";

const initialUserGroup = {
  name: "",
  definition: ""
};

const initialUserGroupsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  authorities: null,
  userGroup: initialUserGroup
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const userGroupSlice = createSlice({
  name: "userGroups",
  initialState: initialUserGroupsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getUserGroups
    userGroupsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getUserGroup
    userGroupFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.userGroup = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanUserGroupsState
    userGroupsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
      state.userGroup = initialUserGroup;
    }
  }
});